import { Box, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import InternationalDealersFinder from './InternationalDealersFinder'
import USDealersFinder from './USDealersFinder'
import { useState } from 'react'

export default function DealersFinderContainer() {
  const [countrySelected, setCountrySelected] = useState('none')

  return (
    <Box>
      <Typography variant='h6' sx={{ textAlign: 'left', mb: 2 }}>
        <FormattedMessage id='sales.selectYourCountryTo' />
      </Typography>
      <InternationalDealersFinder countrySelected={countrySelected} setCountrySelected={setCountrySelected} />
      {countrySelected === 'us' && <USDealersFinder />}
    </Box>
  )
}
